<template>
    <div ref="madeForm">
      <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
      <span slot="dialog_footer" class="dialog-footer">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
    </div>
  </template>
  
  <script>
  import _ from 'lodash'

  import { rectifyConfirm } from "../api";

  export default {
    components: {  },
    props: {
      transmitData: {
        required: true,
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data () {
      return {
        visible: false,
        title: '',
        show: false,
        loading: false,
        formData: {
        },
        optionForm: {
          ...this.$store.state.formOption,
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 150,
          span: 12,
          addText: '新增检查项',
          column: [
          {
              label: "整改备注",
              prop: "remark",
              type: "textarea",
              hide: true,
              maxlength: 200,
              showWordLimit: true,
              span: 24,
              minRows: 3,
              overHidden: true,
            },
            {
            label: "上传照片",
            prop: "remarkPhotos",
            type: "upload",
            multiple: true,
            drag: true,
            tip: "支持多图上传, 最多可上传5张图片",
            limit: 5,
            action: `/api/blade-resource/oss/endpoint/put-file-attach`,
            propsHttp: { res: "data", url: "link" },
            dataType: "string",
            listType: "picture-card",
            span: 24,
          },
           
          ]
        },
        list: [],
        optionConfig: {
          columnType: this.transmitData.type,
          addBtn: false,
          delBtn: false,
          align: 'center',
          height: '40vh',
          column: [
            {
              label: '检查项目',
              prop: 'itemName',
              required: true,
              disabled: true,
            },
            {
              label: '检查标准',
              prop: 'checkListStandard',
              precision: 2,
              required: true,
              disabled: true,
            },
            {
              label: '检查结果',
              prop: 'checkResult',
              required: true,
              dicData: this.$store.getters.commonDict['area_name'],
              type: "select",
  
            },
            {
              label: '现场照片',
              prop: 'problemDescription',
              type: 'updata-img',
              url: '/api/produce/file-upload/uploadCheckPhoto'
            },
            {
              label: "描述",
              prop: "remark",
              type: 'textarea',
              maxlength: 200,
              span: 24,
              minRows: 3,
            },
          ]
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        const { type, id } = this.transmitData
        type !== 'add' && this.getDetail(id)

      },
      //提交
      async submitForm () {
        console.log('this.formData',this.formData)
        rectifyConfirm({
          ...this.formData,
          id:this.transmitData.id
        }).then(({data})=>{
          if(data.code === 200){
            this.$message.success(data.msg)
            this.$emit('handleClose')
          }
          console.log('data',data)
        })
   
      },


 
    }
  }
  </script>
  <style scoped lang="scss">
  .title {
    margin: 10px 0;
    font-size: 20px;
    color: #363636;
  }
  </style>
  